import { useRef, useCallback } from 'react';

/**
 * A React hook that ensures a callback function is only called once.
 *
 * @returns A callback function that will only execute once.
 */
export function useCallbackOnce() {
  const isCalledRef = useRef(false);

  return useCallback((callback: () => void) => {
    if (!isCalledRef.current) {
      isCalledRef.current = true;
      callback();
    }
  }, []);
}
